"use strict";
exports.__esModule = true;
var array_points_1 = require("./array-points");
exports.SimplifyAP = array_points_1.SimplifyAP;
var latlong_points_1 = require("./latlong-points");
exports.SimplifyLL = latlong_points_1.SimplifyLL;
var object_points_1 = require("./object-points");
exports.Simplify = object_points_1.Simplify;
